import React from "react";
import styled from "styled-components";
import { Logo } from "../../../assets/images/Logo";
import { Heading } from "../Heading/Heading";

export const Header = ({ title }) => {
  return (
    <HeaderContainer>
      <MainLogoContainer>
        <LogoContainer>
          <Logo />
        </LogoContainer>
        <Heading size={2} text={"Grensa.AI"} />
      </MainLogoContainer>
      <Divider />
      <Heading size={2} text={title} />
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 2.5rem;
  margin-bottom: 2rem;
`;

const LogoContainer = styled.div`
  height: inherit;
`;

const Divider = styled.div`
  width: 1.75rem;
  height: 0px;
  margin: 1rem 0;
  border: 1px solid #0c0c0e;
  transform: rotate(90deg);
  border-radius: 2px;
`;

const MainLogoContainer = styled.div`
  width: 9.375rem;
  height: inherit;
  display: flex;
  justify-content: space-between;
`;
